module.exports = __webpack_public_path__ + "experience-cbefa654.webp";